export default function Footer() {
  const footerLinks = [
    { label: '黑料爆料', href: '#cards' },
    { label: '视频专区', href: '#media' },
    { label: '吃瓜社区', href: '#app' },
    { label: '投稿联系', href: '#contact' },
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
  ];

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="relative bg-background-900 text-white">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading font-black text-2xl tracking-tight text-white block mb-4">
              91黑料网
            </span>
            <p className="text-sm text-white/50 leading-relaxed mb-6">
              全网最敢说的黑料吃瓜与爆料曝光平台。
              聚焦娱乐圈、网红圈、商业圈、直播圈等九大领域，
              每日更新最新吃瓜内容，深度追踪热点事件，
              为吃瓜群众提供真实、及时、全面的内容服务。
            </p>
            <div className="flex items-center gap-3">
              {['ri-wechat-line', 'ri-share-circle-line', 'ri-video-line', 'ri-live-line'].map((icon) => (
                <span key={icon} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                  <i className={`${icon} text-white/70 text-sm`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm mb-4">热门专题</h4>
            <ul className="space-y-2.5">
              {['娱乐圈翻车', '直播造假', 'MCN黑幕', '综艺剪辑', '网红解约', '品牌曝光'].map((t) => (
                <li key={t}>
                  <a
                    href="#cards"
                    onClick={(e) => scrollTo(e, '#cards')}
                    className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              91黑料网与多家行业媒体及内容平台保持紧密合作关系，共同推动行业信息透明化建设。合作伙伴信息持续更新中。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30 text-center sm:text-left">
            &copy; 2020 - 2026 91黑料网 版权所有。本站内容仅供吃瓜娱乐，不构成任何投资或法律建议。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/30 cursor-pointer hover:text-white/50 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-white/30 cursor-pointer hover:text-white/50 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-xs text-white/30 cursor-pointer hover:text-white/50 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}